export function phoneFormatter(params: any) {
  if (!params.value) return params.value;

  const parts = params.value.toString().match(/^(\d{4})(\d{3})(\d{2,5})$/);
  if (!parts) return params.value;

  return `${parts[1]} ${parts[2]} ${parts[3]}`;
}
